import React, { useEffect, useState } from "react";
import useCustomMutate from "../../../hooks/useMutate";
import { updateClient } from "../../../sevices/clientApi";

const UpdateRentalAccess = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(data?.active);

  const { mutate } = useCustomMutate(
    updateClient,
    ["clients"],
    () => {
      setLoading(false);
    },
    () => {
      setIsChecked(data?.active);
    }
  );
  const onChange = (event) => {
    setLoading(true);
    setIsChecked(event.target.checked);
    const reqBody = {
      id: data.client_id,
      data: { is_rental_service: event.target.checked },
    };
    mutate(reqBody);
  };

  useEffect(() => {
    setIsChecked(data?.active);
  }, [data?.active]);

  return (
    <div>
      <label class="custom-checkbox-large">
        <input
          type="checkbox"
          id={`assign-checkbox-${data?.client_id}`}
          onClick={onChange}
          defaultChecked={data?.active}
          checked={isChecked}
          disabled={loading}
        />
        <span
          class="checkmark-large"
          //   style={{ backgroundColor: `${!inspector ? "#ebebeb" : ""}` }}
        ></span>
      </label>
    </div>
  );
};

export default UpdateRentalAccess;
